export const dashboardPath = '/dashboard';
export const pendingActionsPath = '/dashboard/pending-actions';
